import * as R from 'ramda'

const root = state => R.pathOr({}, ['playbooks'], state)

export const clickMap = state => R.pathOr({}, ['clickMap'], root(state))
